import { createSelector } from "reselect";
import _ from "lodash";
import { filter, keyBy, isPlainObject } from "lodash/fp";

const getSurveyFilterSelectList = (state, ownProps) =>
	ownProps.surveyTransactionList;

const constructSector = createSelector(
	[getSurveyFilterSelectList],
	surveyFilterSelectList => {
		if (surveyFilterSelectList !== []) {
			console.log("helle getSurveyFilterSelectList");
		}
	}
);

export default constructSector;



// WEBPACK FOOTER //
// src/redux/selectors/constructSector.js